import { SubtypeDPParamsHistoricalProps } from './props';
import { useSubtypeDPParamsHistorical } from './hook';
import { Table } from '../../../../components/general/table';
import { useState } from 'react';

export const SubtypeDPParamsHistorical = (
    historical: SubtypeDPParamsHistoricalProps,
    showHistorical?: boolean
) => {
    const { columns, rows } = useSubtypeDPParamsHistorical(historical);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });

    const handlePaginationChange = (newPagination: {
        page: number;
        pageSize: number;
    }) => {
        setPaginationModel(newPagination);
    };

    const paginatedRows = rows.slice(
        paginationModel.page * paginationModel.pageSize,
        (paginationModel.page + 1) * paginationModel.pageSize
    );

    if (!showHistorical) {
        return null;
    }

    return (
        <Table
            columns={columns}
            rows={paginatedRows}
            rowCount={rows.length}
            paginationModel={paginationModel}
            onPaginationModelChange={handlePaginationChange}
            pageSizeOptions={[10, 20, 50]}
            disableRowSelectionOnClick
        />
    );
};
